import { render, staticRenderFns } from "./RightDrawer.vue?vue&type=template&id=4dd93cf2&scoped=true&"
import script from "./RightDrawer.vue?vue&type=script&lang=ts&"
export * from "./RightDrawer.vue?vue&type=script&lang=ts&"
import style0 from "./RightDrawer.vue?vue&type=style&index=0&id=4dd93cf2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd93cf2",
  null
  
)

export default component.exports